<template>
  <b-container>
    <b-jumbotron>
      <form @submit.prevent="login">
        <h3>Sign In</h3>

        <div class="form-group">
          <label>Username</label>
          <input type="text" name="username" class="form-control form-control-lg" v-model="username"/>
        </div>

        <div class="form-group">
          <label>Password</label>
          <input type="password" class="form-control form-control-lg" v-model="password"/>
        </div>

        <button type="submit" class="btn btn-dark btn-lg btn-block">Sign In</button>

        <p class="forgot-password text-right mt-2 mb-4">
<!--          <router-link to="/forgot-password">Forgot password ?</router-link>-->
        </p>

      </form>
    </b-jumbotron>
  </b-container>
</template>
<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {},
  methods: {
    async login() {
      const loggedIn = await this.$store.dispatch("login", {
        username: this.username,
        password: this.password
      });
      if (loggedIn.error){
        this.$warn(this.$t('"Username or password incorrect"'))
      }else
      this.$router.push("/orders")
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped>
</style>
